import { createAsyncThunk, createSlice, createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { listValuesPerOrgId, GraphQL } from '../../utils/api';
import { createValue as gqlCreateValue} from '../../graphql/mutations';

const initialState: any = {
  data: [],
  status: 'idle',
};

export const fetchStageValues = createAsyncThunk(
  'company/fetchValues', async (customerId: string) => {
    const values = await listValuesPerOrgId(customerId)
    return values
  }
);

export const createValue = createAsyncThunk(
  'company/createValue', async (variables: any) => {
    const query = gqlCreateValue;
    await GraphQL({ query, variables });
  }
);

export const valuesSlice = createSlice({
  name: 'values',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStageValues.pending, (state: any) => {
        state.status = 'loading';
      })
      .addCase(fetchStageValues.fulfilled, (state: any, { payload }: any) => {
        state.status = 'idle';
        state.data = payload;
      })
      .addCase(fetchStageValues.rejected, (state: any, { payload }: any) => {
        state.status = 'failed';
        console.error('Fetching values auth data failed.', payload)
      })
      .addCase(createValue.pending, (state: any) => {
        state.status = 'loading';
      })
      .addCase(createValue.fulfilled, (state: any) => {
        state.status = 'idle';
      })
      .addCase(createValue.rejected, (state: any, { payload }: any) => {
        state.status = 'failed';
        console.error('Fetching values auth data failed.', payload)
      });
  },
});

export const selectValues = (
  state: RootState
) => {
  return state?.values?.data;
};

export const selectMemoValues = createSelector(
  selectValues,
  (selectValues) => selectValues
);

export const selectValueById = createSelector(
  [selectMemoValues, (_state, id) => id],
  (items, id) =>
    items?.find((value: any) => {
      return value.id === id;
    })
);

export default valuesSlice.reducer;
